import React, { useState, useEffect } from 'react'
import firebase from 'firebase/app'
import { Form, Col, Image, Spinner, Button } from 'react-bootstrap'
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks'
import { Link, Redirect } from 'react-router-dom'
import { HomePageSkeleton } from '../components/Skeletons'

import PhoneLoginForm from '../components/PhoneLoginForm'

import { OTP_VIEW, HOME_VIEW, CHILD_AGE_VIEW } from '../resources/appRoutes'
import { AUTHENTICATE_USER } from '../resources/mutations'
import { useGenerateOtp, useVerifyOtp } from '../hooks/dataSource'

import {
  PhoneInput,
  Description,
  PrimaryButton,
  ProviderContainer,
  Provider,
  Label,
  // LoginContainer,
  MainContainer,
  Title,
} from '../theme'
import {} from '../'
import FullScreenLoader from '../components/FullScreenLoader'

import { LOGIN_VIEW_LABELS } from '../resources/labels.json'

require('firebase/auth')
const { PAGE_TITLE, SUBTITLE, LOGIN_WITH, TITLE } = LOGIN_VIEW_LABELS

// const LOGIN_WITH = 'Or Login With'
// const ENTER_NUMBER = 'Enter Your Mobile Number'
// const SUBMIT = 'Submit'

function useFacebookLogin(props) {
  const [saveUser, { loading: savingUser, error, data }] = useMutation(
    AUTHENTICATE_USER
  )
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    props.firebase.auth
      .getRedirectResult()
      .then(function (result) {
        if (result.user) {
          const { user } = result
          const { ma } = user
          const adId = localStorage.getItem('ad_id')

          localStorage.setItem('accessToken', ma)
          saveUser({ variables: { accessToken: ma, adId } })
        }
        setLoading(false)
      })
      .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        // The email of the user's account used.
        var email = error.email
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential
        if (errorCode === 'auth/account-exists-with-different-credential') {
          firebase
            .auth()
            .fetchSignInMethodsForEmail(email)
            .then((providers) => {
              firebase
                .auth()
                .signInWithCredential(credential)
                .then((user) => {
                  user.linkWithCredential(credential)
                })
            })
            .catch((error) => {
              throw error
            })
        } else {
          throw error
        }
        setLoading(false)
        // ...
      })
  }, [props])
  return { loading: loading || savingUser, error, data }
}

function LoginView(props) {
  const { loading, error, data } = useFacebookLogin(props)
  const [genOtp] = useGenerateOtp()
  const [facebookLoading, setFbLoader] = useState(false)

  useEffect(() => {
    window.sendEvent({
      type: 'Screen Viewed',
      data: { screen: 'Sign Up' },
    })
  }, [])

  const onLogin = (type) => {
    window.sendEvent({
      type: 'Signup Clicked',
      data: { type },
    })
  }

  useEffect(() => {
    if (error) {
      window.sendEvent({
        type: 'Error - No Internet',
        data: { screen: 'Sign Up' },
      })
    }
  }, [error])

  if (loading) return <FullScreenLoader title={data && data.user} />

  if (data && data.user) {
    Object.keys(data.user).forEach((k) => {
      if (data.user[k] || data.user[k] === 0) {
        localStorage.setItem(k, data.user[k])
      }
    })
    return (
      <Redirect
        to={{
          pathname: HOME_VIEW,
        }}
      />
    )
  }

  return (
    <MainContainer
      className="d-flex flex-column justify-content-around"
      height={'100vh'}
      bgcolor={'#FFDD50'}
      textAlign={'center'}
    >
      <h2 className="font">{TITLE}</h2>
      <Image
        src="/images/TopParentRegisterationBanner.png"
        className="mb-1"
        style={{
          height: '35vh',
          width: '100%',
          objectFit: 'contain',
        }}
      />

      <PhoneLoginForm
        onSubmit={(number) => {
          onLogin('Phone')
          genOtp(number, true)
          props.history.push(`${OTP_VIEW}?number=${number}`)
        }}
      />
      {/* <Image src="/images/logo.png" className="mb-1" style={{ height: 120 }} />
      <Label className="my-1">{PAGE_TITLE}</Label>
      <Description>{SUBTITLE}</Description>
      // <PhoneLoginForm
      //   onSubmit={(number) => {
      //     onLogin('Phone')
      //     genOtp(number, true)
      //     props.history.push(`${OTP_VIEW}?number=${number}`)
      //   }}
      // />
      <ProviderContainer>
        <Label>{LOGIN_WITH}</Label>
        {facebookLoading ? (
          <Spinner
            className="mt-2"
            as="span"
            animation="border"
            size="md"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <>
            <Provider
              style={{ width: '30px' }}
              src="/images/fb.png"
              roundedCircle
              onClick={() => {
                onLogin('Facebook')
                setFbLoader(true)
                props.firebase.loginWithFacebook()
              }}
            /> */}

      {/* <Button */}
      {/*   style={{ */}
      {/*     backgroundColor: '#3B5998', */}
      {/*     color: 'white', */}
      {/*     padding: '10px 14px', */}
      {/*     fontSize: '16px', */}
      {/*     marginTop: '5%', */}
      {/*     width: '14rem', */}
      {/*   }} */}
      {/*   onClick={() => { */}
      {/*     onLogin('Facebook') */}
      {/*     setFbLoader(true) */}
      {/*     props.firebase.loginWithFacebook() */}
      {/*   }} */}
      {/* > */}
      {/*   <i */}
      {/*     className="fa fa-facebook fa-fw" */}
      {/*     style={{ */}
      {/*       fontSize: '16px', */}
      {/*     }} */}
      {/*   ></i>{' '} */}
      {/*   Login with Facebook */}
      {/* </Button> */}
      {/* <Button */}
      {/*   style={{ */}
      {/*     backgroundColor: '#dd4b39', */}
      {/*     color: 'white', */}
      {/*     padding: '10px 14px', */}
      {/*     fontSize: '16px', */}
      {/*     marginTop: '5%', */}
      {/*     border: 'none', */}
      {/*     width: '14rem', */}
      {/*   }} */}
      {/*   onClick={() => { */}
      {/*     onLogin('Google') */}
      {/*     setFbLoader(true) */}
      {/*     props.firebase.loginWithGoogle() */}
      {/*   }} */}
      {/* > */}
      {/*   <i */}
      {/*     className="fa fa-google fa-fw" */}
      {/*     style={{ */}
      {/*       fontSize: '16px', */}
      {/*     }} */}
      {/*   ></i>{' '} */}
      {/*   Login with Google */}
      {/* </Button> */}
      {/* </>
        )}
      </ProviderContainer> */}
    </MainContainer>
  )
}

export default LoginView
